/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-indent */
/* eslint-disable prettier/prettier */
import React, { useContext, useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import Carousel from 'react-material-ui-carousel'
import { Paper } from '@material-ui/core'
import Title from '../Title/Title';
// import AboutImg from '../Image/AboutImg';
import PortfolioContext from '../../context/context';

const About = () => {
    const { about } = useContext(PortfolioContext);
    const { img, paragraphOne, paragraphTwo, paragraphThree, resume } = about;

    const [isDesktop, setIsDesktop] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (window.innerWidth > 769) {
            setIsDesktop(true);
            setIsMobile(false);
        } else {
            setIsMobile(true);
            setIsDesktop(false);
        }
    }, []);

    const items = [
        {
            about:
                <div className="about-wrapper__info">
                    <p className="about-wrapper__info-text">
                        {paragraphOne ||
                            'I am a full stack software engineer who is a computer hardware enthusiast, avid problem solver, passionate about serving others, and dedicated to learning new things.'}
                    </p>
                    <p className="about-wrapper__info-text">
                        {paragraphTwo ||
                            'I have experience working with a variety of languages and technologies such as JavaScript, Python, React, Redux, HTML, CSS, Node.js, PostgreSQL, Express, Flask, AWS, D3.js, and Docker.'}
                    </p>
                    <p className="about-wrapper__info-text">
                        {paragraphThree || 'I enjoy creating web applications that look and feel great while being useful for many others. I also enjoy playing the saxophone and guitar, cycling, and photography.'}
                    </p>

                    <span className="d-flex mt-3">
                        <a
                            target="blank"
                            rel="noopener noreferrer"
                            className="cta-btn cta-btn--resume"
                            href={require("../../assets/Ryu_Douglas_resume.pdf")}
                        >
                            View Resume
                        </a>
                    </span>
                </div>
        },
        {
            education:
                <div className="about-wrapper__info">
                    <p className="about-wrapper__info-text">
                        <img className="aa-logo" src={require("../Image/aa-logo.svg")} /> <span className="education__name">App Academy</span>
                        <p>
                            - Rigorous 1000-hour software development course with a {"<"} 3% acceptance rate
                        </p>
                    </p>
                    <p className="about-wrapper__info-text">
                        <img className="usfk-logo" src={require("../Image/usfk-logo.png")} /> <span className="education__name">United States Forces Korea</span>
                        <div>
                            - U.S. Army Commendation Medal
                        </div>
                        <p>
                            - R.O.K. Army Commendation for Excellence
                        </p>
                    </p>
                    <p className="about-wrapper__info-text">
                        <img className="usfk-logo" src={require("../Image/colgate-logo.png")} /> <span className="education__name">Colgate University</span>
                        <p>
                            - B.A. Biochemistry
                        </p>
                    </p>
                </div>
        },
    ]

    return (
        <section id="about">
            <Container>
                <Title title="About Me" />
                <Row className="about-wrapper">
                    <Col md={6} sm={12}>
                        <Fade bottom duration={1000} delay={600} distance="30px">
                            <div className="about-wrapper__image">
                                {/* <AboutImg alt="profile picture" filename={img} /> */}
                                <img style={{ width: "350px" }} className="rounded shadow-lg" src={require("../../images/profile.jpg")} />
                            </div>
                        </Fade>
                    </Col>
                    <Col md={6} sm={12}>
                        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
                            <Carousel animation={"fade"} autoPlay={false}>
                                {
                                    items.map((item, i) => <Item key={i} item={item} />)
                                }
                            </Carousel>
                        </Fade>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

function Item(props) {
    return (
        <>
            <div>{props.item.about}</div>
            <div>{props.item.education}</div>
        </>
    )
}

export default About;
